<template>
  <div>
    <label class="text-xs text-gray-600 block mb-1">{{ label }}</label>
    <FloatingMenu placement="bottom" :offset="[0, 4]">
      <template #activator="{ show }">
        <button
          :disabled="disabled"
          class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm text-left flex justify-between items-center disabled:bg-gray-100"
          @click="show()"
        >
          <span>{{ model }}</span>
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </template>
      <template #content="{ hide }">
        <div
          class="w-[28rem] flex flex-col text-[#516A75] border bg-white rounded-md shadow-lg"
        >
          <button
            v-for="modelOption in availableModels"
            :key="modelOption"
            class="py-2 px-4 hover:bg-black/5 w-full text-left block"
            :class="{ 'bg-black/5': model === modelOption }"
            @click="
              () => {
                model = modelOption
                hide()
              }
            "
          >
            <div>{{ modelOption }}</div>
            <div
              v-if="
                showCostWarning &&
                !modelOption.includes('mini') &&
                !modelOption.includes('nano')
              "
              class="text-xs text-orange-600 mt-0.5"
            >
              Will increase costs
            </div>
          </button>
        </div>
      </template>
    </FloatingMenu>
  </div>
</template>

<script setup lang="ts">
import FloatingMenu from '@app/components/Global/FloatingMenu.vue'
import { ref } from 'vue'

defineProps<{
  label: string
  disabled?: boolean
  showCostWarning?: boolean
}>()

const model = defineModel<string>({ required: true })

const availableModels = ref([
  'gpt-5.1',
  'gpt-4.1',
  'gpt-5-mini',
  'gpt-4.1-mini',
  'gpt-5-nano',
  'gpt-4.1-nano',
])
</script>
